/** QuickHouse — Objet de bibliothèque en 3D : composition de primitives (boîtes/cylindres).
 *  Repère local : origine = centre de l'empreinte au sol, z du catalogue = vertical. */
import { findCatalogItem } from '../../shared/catalog.js';

export default function ItemMesh({ item, catalog, floorHeight, elevM }) {
  const entry = findCatalogItem(catalog, item.catalogId);
  if (!entry) return null;
  const s = item.scale ?? 1;
  const elevation = item.elevation
    ?? (entry.elevation === 'ceiling' ? floorHeight - entry.size.h * s : entry.elevation);
  return (
    <group
      position={[item.position.x / 100, elevM + elevation / 100, item.position.y / 100]}
      rotation={[0, (-(item.rotation ?? 0) * Math.PI) / 180, 0]}
      scale={[s, s, s]}
    >
      {entry.parts.map((p, i) => (
        p.k === 'box' ? (
          <mesh key={i} position={[p.x / 100, (p.z + p.h / 2) / 100, p.y / 100]} castShadow receiveShadow>
            <boxGeometry args={[p.w / 100, p.h / 100, p.d / 100]} />
            <meshStandardMaterial color={p.color} transparent={p.op !== undefined} opacity={p.op ?? 1} />
          </mesh>
        ) : (
          <mesh key={i} position={[p.x / 100, (p.z + p.h / 2) / 100, p.y / 100]} castShadow receiveShadow>
            <cylinderGeometry args={[p.r / 100, p.r / 100, p.h / 100, 24]} />
            <meshStandardMaterial color={p.color} transparent={p.op !== undefined} opacity={p.op ?? 1} />
          </mesh>
        )
      ))}
    </group>
  );
}
